import { CalendarDays } from "lucide-react";

// YallBot-style "Daily Outlook" board — each SPC outlook day at a glance (Day 1-3 categorical risk over Georgia).
const RISK = {
  HIGH: { n: "5/5", name: "High", color: "#b5179e", text: "#fff" },
  MDT:  { n: "4/5", name: "Moderate", color: "#d90429", text: "#fff" },
  ENH:  { n: "3/5", name: "Enhanced", color: "#f6701c", text: "#fff" },
  SLGT: { n: "2/5", name: "Slight", color: "#ffd60a", text: "#0a0f1c" },
  MRGL: { n: "1/5", name: "Marginal", color: "#2a9d3a", text: "#fff" },
  TSTM: { n: "", name: "General Storms", color: "#86c232", text: "#0a0f1c" },
};
const CALM = { n: "", name: "No Severe Risk", color: "#1f3a5f", text: "#c3ccd8" };
export const SEVERE_RISKS = ["MRGL", "SLGT", "ENH", "MDT", "HIGH"];

const dayLabel = (day) => (day === 1 ? "Today" : day === 2 ? "Tomorrow" : new Date(Date.now() + (day - 1) * 86400000).toLocaleDateString("en-US", { weekday: "long", timeZone: "America/New_York" }));
const dayDate = (day) => new Date(Date.now() + (day - 1) * 86400000).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "America/New_York" });

export function SevereOutlookSlide({ days = [] }) {
  const list = (days || []).slice(0, 3);
  if (!list.length) return null;
  return (
    <div data-testid="severe-outlook-slide" className="relative h-full w-full overflow-hidden" style={{ background: "linear-gradient(140deg, #14233f 0%, #0c1830 58%, #0a0f1c 100%)" }}>
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #fff 0 2px, transparent 2px 28px)" }} />
      <div className="relative flex h-full w-full flex-col px-[54px] py-[32px]">
        <div className="flex items-center gap-2.5">
          <span className="flex items-center gap-2 rounded-full bg-[#2f7bed] px-4 py-1.5 font-oswald text-[17px] font-black uppercase tracking-[0.2em] text-white">
            <CalendarDays className="h-5 w-5" strokeWidth={2.6} /> Severe Weather Outlook
          </span>
        </div>
        <div className="mt-2 font-oswald text-[52px] font-black uppercase leading-none text-white">The Days Ahead</div>
        <div className="mt-1 font-plex text-[22px] font-medium text-white/55">Storm Prediction Center risk for Georgia</div>

        <div className="mt-6 grid flex-1 grid-cols-3 gap-6">
          {list.map((d) => {
            const r = (d.ga_risk && RISK[d.ga_risk]) || CALM;
            return (
              <div key={d.day} className="flex flex-col overflow-hidden rounded-[14px] bg-white/[0.05] ring-1 ring-white/12" data-testid={`outlook-day-${d.day}`}>
                <div className="flex flex-col gap-0.5 px-6 pt-5">
                  <span className="font-oswald text-[34px] font-black uppercase leading-none text-white">{dayLabel(d.day)}</span>
                  <span className="font-plex text-[21px] font-semibold text-white/55">{dayDate(d.day)}</span>
                </div>
                <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-3 px-5 pb-6">
                  <div className="flex h-[150px] w-[150px] flex-col items-center justify-center rounded-full" style={{ background: r.color, color: r.text }}>
                    {r.n && <span className="font-oswald text-[56px] font-black leading-none">{r.n}</span>}
                    {!r.n && <span className="font-oswald text-[30px] font-black uppercase leading-none">{d.ga_risk ? "TSTM" : "NONE"}</span>}
                  </div>
                  <span className="text-center font-oswald text-[30px] font-black uppercase leading-tight" style={{ color: r.color === "#ffd60a" || r.color === "#86c232" ? "#ffd60a" : r.text === "#fff" ? "#fff" : "#fff" }}>{r.name}</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-3 font-plex text-[19px] font-medium tracking-wide text-white/45">
          Source: NOAA Storm Prediction Center convective outlooks · risk is the chance of severe storms, not everyday rain
        </div>
      </div>
    </div>
  );
}
